export const REGEX = {
  PHONE_NUBMER: /^(\+62|0)8[1-9][0-9]{7,17}$/,
  PHONE_NUMBER_SECONDARY: /^(62|\+62|0)8[1-9][0-9]{6,17}$/,
  PHONE_NUMBER_THIRD: /^(\+62|62|0)8[1-9][0-9]{7,11}$/,
};
